// extracted by mini-css-extract-plugin
export default {"primaryColor":"#121212","primaryColorWithAlpha":"rgba(18,18,18,.1019607843)","mainBgColor":"#fff","secondBgColor":"#26262e"};